import {register} from '../vendor/theme-scripts/theme-sections';
import toggleGrid from '../features/collection-grid-toggle';
import {accordion} from '../features/accordion';
import {RadioSwatch, swatchGridSection} from '../features/swatch';
import {PopoutSelect} from '../features/popout';
import {collectionFiltersSidebar} from '../features/collection-filters-sidebar';
import collectionFiltersForm from '../features/collection-filters-form';
import {siblings} from '../features/siblings';
import {ProductGridItem} from '../features/product-grid-item';
import {ProductGridItemVariant} from '../features/product-grid-item-variant';
import {ProductGridItemImage} from '../features/product-grid-item-image';
import Sort from '../features/collection-sort';

var selectors = {
  swatch: 'data-swatch',
};

class Collection {
  constructor(section) {
    this.section = section;
    this.container = this.section.container;
    this.swatches = this.container.querySelectorAll(`[${selectors.swatch}]`);
    this.init();
  }

  init() {
    new Sort(this.section);
  }
}

const collectionSection = {
  onLoad() {
    this.collection = new Collection(this);
  },
};

register('collection', [collectionSection, collectionFiltersSidebar, collectionFiltersForm, toggleGrid, swatchGridSection, accordion, siblings]);

if (!customElements.get('popout-select')) {
  customElements.define('popout-select', PopoutSelect);
}

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('product-grid-item')) {
  customElements.define('product-grid-item', ProductGridItem);
}

if (!customElements.get('product-grid-item-variant')) {
  customElements.define('product-grid-item-variant', ProductGridItemVariant);
}

if (!customElements.get('product-grid-item-image')) {
  customElements.define('product-grid-item-image', ProductGridItemImage);
}
